import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#F3F0EA]">
        <div className="text-[#0A1128]/50 text-sm animate-pulse">Loading BridgeHub...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
